import { InternalServerError } from './errors';
import {
  HttpApiEndpoint,
  HttpApiGroup,
  HttpApiSchema,
  OpenApi,
} from 'effect/unstable/httpapi';
import { Schema } from 'effect';
import { UserAuthMiddleware } from './middleware';

const SupportChatIdentityConfigured = Schema.Struct({
  configured: Schema.Literal(true),
  identifier: Schema.String,
  email: Schema.String,
  name: Schema.String,
  identifierHash: Schema.String,
});

const SupportChatIdentityNotConfigured = Schema.Struct({
  configured: Schema.Literal(false),
});

const GetIdentityResponse = Schema.Union([
  SupportChatIdentityConfigured,
  SupportChatIdentityNotConfigured,
]);

const getIdentityEndpoint = HttpApiEndpoint.get('GetIdentity', '/identity', {
  success: GetIdentityResponse.pipe(HttpApiSchema.status(200)),
  error: InternalServerError,
})
  .middleware(UserAuthMiddleware)
  .annotate(OpenApi.Summary, 'Get Support Chat Identity')
  .annotate(
    OpenApi.Description,
    'HMAC-signed helpdesk identity for the current user, used by the mobile support chat widget for identity validation. Returns configured: false when the server-side HMAC secret is not set, in which case clients fall back to anonymous chat.',
  );

export const supportChatGroup = HttpApiGroup.make('SupportChat')
  .add(getIdentityEndpoint)
  .prefix('/support-chat');
